import {Tooltip, Typography, Icon} from "@bonprix/design-system";
import React, {useRef} from "react";
import Glossary from "../../helper/glossary.js";
import {getSustainabilityIconName} from "@product/data/sustainability/sustainability-icon-mapping.ts";
import GlossaryEntry from "../../components/glossary/GlossaryEntry.jsx";
import Landmark from "@core/scripts/components/landmark-adapter";

export default function SustainabilityCategories({categories, glossaryContent}) {
    const glossary = Glossary.create(glossaryContent);

    if (!categories || categories.length === 0) {
        return <></>;
    }

    return <div className={"sustainability-categories"}>
        {categories.map((category, index) => (
            <SustainabilityCategory key={`sus-standard-${index}`}
                                    glossary={glossary}
                                    category={category}/>
        ))}
    </div>;

}

function SustainabilityCategory({glossary, category}) {

    if (!category) {
        return <></>;
    }
    if (!category.name || !category.attributes || category.attributes.length === 0) {
        return <></>;
    }

    const categoryIconName = getSustainabilityIconName(category.icon.featureName);

    return <div className={"sustainability-category"}>
        <div className={"sustainability-category-column"}>
            <div className={"sustainability-standard-icon-wrapper"}>
                <Icon variant={categoryIconName}/>
            </div>
        </div>
        <div className={"sustainability-category-column"}>
            <div className={"sustainability-category-name"}>
                <Typography variant={"body1"}>{category.name}</Typography>
            </div>
            <div className={"sustainability-category-attributes"}>
                {category.attributes.map((attribute, index) => <SustainabilityCategoryAttribute
                    key={`sus-${category.name?.toLowerCase()}-attribute-${index}`}
                    glossary={glossary}
                    attribute={attribute}/>)}
            </div>
        </div>
    </div>
}

function SustainabilityCategoryAttribute({glossary, attribute}) {
    const attributeContent = glossary.glossify(attribute.name,
        (attributeName, glossaryEntry) => (
            <SustainabilityCategoryAttributeGlossaryPart
                key={`sustainability-category-attribute-part-${attribute.name?.toLowerCase()}`}
                attributeName={attributeName}
                glossaryEntry={glossaryEntry}/>),
        (attributePart, index) => (
            <SustainabilityCategoryAttributeNonGlossaryPart
                key={`sustainability-category-attribute-part-${attribute.name?.toLowerCase()}-${index}`}
                attributePart={attributePart}/>)
    );
    return <span className={"sustainability-category-attribute"}>
        {attributeContent}
    </span>
}

function SustainabilityCategoryAttributeGlossaryPart({attributeName, glossaryEntry}) {
    return <span className={"sustainability-category-attribute-part"}>
        <Typography variant={"body1"}>
           <GlossaryEntry
               label={attributeName}
               entry={glossaryEntry}
               onGlossaryLabelClicked={(label) => Landmark.sendClickLandmark(`adp_glossary\\${label}`)}
           />
        </Typography>
    </span>
}

function SustainabilityCategoryAttributeNonGlossaryPart({attributePart}) {
    return <span className={"sustainability-category-attribute-part"}>
        <Typography variant={"body1"}>{attributePart}</Typography>
    </span>
}
